<template>
  <div>
    <el-radio-group v-model="isCollapse" style="margin: 10px 0px;display: flex;flex-flow: column;">
      <el-radio-button :label="false">展开</el-radio-button>
      <el-radio-button :label="true">收起</el-radio-button>
    </el-radio-group>
    <el-menu default-active="2"  :collapse="isCollapse">
      <el-submenu class="menuLabel" v-for="(item, idx) in menuList" :key="idx" :index="idx.toString()">
        <template slot="title">
          <i class="iconSize" :class="item.menu.icon"></i>
          <span class="menuName">{{ item.menu.name }}</span>
        </template>
        <el-menu-item-group v-for="(itemSub, idx) in item.subMenus" :key="idx">
          <el-menu-item @click="jump(itemSub.href)">{{ itemSub.name }}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import '@/assets/style/icon.css';
import { menuList } from '@/api/user';
export default {
  name: 'left',
  data() {
    return {
      isCollapse: true,
      menuList: [],
      menu: {}
    };
  },
  mounted() {},
  created() {
    // console.log("left组件访问created")
    this.getMenuList();
  },
  methods: {
    getMenuList() {
      // var token = localStorage.getItem('Authorization');
      var that = this;
      that.menuList = [];
      that.menu = {};
      // if (token) {
      menuList({})
        .then(res => {
          if (res.status == 200) {
            var menuList = res.data.menus;
            // console.log(res)
            for (let i = 0; i < menuList.length; i++) {
              let permiss = menuList[i];
              var menu = menuList[i].menu;
              that.menuList.push(permiss);
              if (i) {
                that.menu = menu;
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
      // }
    },
    jump(url) {
      this.$router.push({
        path: url
      });
    }
  }
};
</script>

<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.moneyIcon {
  margin-right: 10px;
  font-size: 20px;
}
.iconSize {
  font-size: 20px;
  margin-right: 10px;
}
.menuLabel {
  margin: 20px 0px;
}
.menuName {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/left.vue